import { AutofocusEffectItem } from './Autofocus';
import { BloomEffectItem } from './Bloom';
import { ChromaticAberrationEffectItem } from './ChromaticAberration';
import { ColorAverageEffectItem } from './ColorAverage';
import { ColorDepthEffectItem } from './ColorDepth';
import { DepthEffectItem } from './Depth';
import { DepthOfFieldEffectItem } from './DepthOfField';
import { GlitchEffectItem } from './Glitch';
import { GridEffectItem } from './Grid';
import { LensFlareEffectItem } from './LensFlare';
import { NoiseEffectItem } from './Noise';
import { OutlineEffectItem } from './Outline';
import { PixelationEffectItem } from './Pixelation';
import { ScanlineEffectItem } from './ScanlineEffect';
import { SelectiveBloomEffectItem } from './SelectiveBloom';
import { SSAOEffectItem } from './SSAO';
import { VignetteEffectItem } from './Vignette';

export const EffectDefinitions = {
  'effect.autofocus': AutofocusEffectItem,
  'effect.bloom': BloomEffectItem,
  'effect.chromaticAberration': ChromaticAberrationEffectItem,
  'effect.colorAverage': ColorAverageEffectItem,
  'effect.colorDepth': ColorDepthEffectItem,
  'effect.depth': DepthEffectItem,
  'effect.depthOfField': DepthOfFieldEffectItem,
  'effect.glitch': GlitchEffectItem,
  'effect.grid': GridEffectItem,
  'effect.lensFlare': LensFlareEffectItem,
  'effect.noise': NoiseEffectItem,
  'effect.outline': OutlineEffectItem,
  'effect.pixelation': PixelationEffectItem,
  'effect.scanline': ScanlineEffectItem,
  'effect.selectiveBloom': SelectiveBloomEffectItem,
  'effect.ssao': SSAOEffectItem,
  'effect.vignette': VignetteEffectItem,
};